import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="section">
      {/* ... your footer content here ... */}
    </footer>
  );
}

export default Footer;
